import React, { useState, useEffect } from "react";
import './homecount.css';
import { useInView } from "react-intersection-observer";

const Counter = ({ from, to, duration }) => {
  const [count, setCount] = useState(from);
  const [ref, inView] = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inView) {
      let start = from;
      const increment = (to - from) / (duration * 60); // ~60fps
      const timer = setInterval(() => {
        start += increment;
        if (start >= to) {
          clearInterval(timer);
          setCount(to);
        } else {
          setCount(Math.floor(start));
        }
      }, 1000 / 60);

      return () => clearInterval(timer);
    }
  }, [inView, from, to, duration]);

  return <span ref={ref}>{count.toLocaleString()}+</span>;
};

const StatsSection = () => {
  return (
    <div className="stats-container-homecountstat">
      <div className="stat-box-homecountstat">
        <h2 className="stat-title-homecountstat">SERVED IN COUNTRIES</h2>
        <p className="stat-number-homecountstat">
          <Counter from={0} to={20} duration={2} />
        </p>
      </div>
      <div className="stat-box-homecountstat">
        <h2 className="stat-title-homecountstat">EXPERIENCE</h2>
        <p className="stat-number-homecountstat">
          <Counter from={0} to={10} duration={2.5} /> YEARS
        </p>
      </div>
      <div className="stat-box-homecountstat">
        <h2 className="stat-title-homecountstat">HAPPY CLIENT</h2>
        <p className="stat-number-homecountstat">
          <Counter from={0} to={5000} duration={3} />
        </p>
      </div>
      <div className="stat-box-homecountstat">
        <h2 className="stat-title-homecountstat">ACCURACY RATING</h2>
        <p className="stat-number-homecountstat">
          <Counter from={0} to={98} duration={3.5} />%
        </p>
      </div>
    </div>
  );
};

export default StatsSection;
